import { getUserContext } from "../../../configs/utils";
import { ROUTE } from "../../../routes";
export const doneAction = async (action, _datastore, { navigateWithClear, network }) => {
    await getUserContext(network, {
        overrideCache: true
    });
    await navigateWithClear(ROUTE.DASHBOARD, { cacheUserContext: true });
};
